import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../Hooks/useFormName';
import { joinClasses } from '../../../Utils/className.util';
import PrescriptionMedicamentsSelect, {
	PrescriptionMedicamentsSelectValue,
} from './PrescriptionMedicamentsSelect';
import ErrorMessage from '../../../Components/Form/components/ErrorMessage';
import InputWrapper from '../../../Components/Form/components/InputWrapper/InputWrapper';

interface PrescriptionMedicamentsSelectFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (value: PrescriptionMedicamentsSelectValue) => void;
	isWrapped?: boolean;
}

const PrescriptionMedicamentsSelectField: React.FC<
	PrescriptionMedicamentsSelectFieldProps
> = ({ name, label, isRequired, className, onChange, isWrapped }) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName || '',
	});

	const component = (
		<div className={joinClasses(['flex-grow-1', className])}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<PrescriptionMedicamentsSelect
				error={error}
				value={field.value}
				onChange={(value: PrescriptionMedicamentsSelectValue) => {
					field.onChange(value);
					onChange?.(value);
				}}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default PrescriptionMedicamentsSelectField;
